import React from "react";
import PropTypes from "prop-types";
import { MODE } from "../../../constants/common";
import AddEditBundle from "./AddEditBundle/AddEditBundle";
import BundleList from "./BundleList/BundleList";
/*istanbul ignore next */
function Bundle(props) {
  const {
    id,
    distributorId,
    catalogId,
    mode,
    onSave,
    onCancel,
    onEdit,
    onNext,
    query,
    onView,
    showColumnPopup,
    onQueryChange,
    signUpApproval,
    permissions,
    setContentId,
    setContentMode,
    setBundleId,
    setBundleMode,
    setCatalogId,
    setCatalogMode,
    onViewHandlerList,
    onEditHandlerList,
  } = props;

  return (
    <div>
      {mode === MODE.LIST ? (
        <BundleList
          id={id}
          query={query}
          showColumnPopup={showColumnPopup}
          onCancelTableColumnSelection={props.onCancelTableColumnSelection}
          onView={onView}
          onEdit={onEdit}
          setQuery={onQueryChange}
          signUpApproval={signUpApproval}
          permissions={permissions}
        />
      ) : (
        <AddEditBundle
          id={id}
          query={query}
          distributorId={distributorId}
          bundleId={catalogId}
          setSelectedSubTab={props.setSelectedSubTab}
          setContentId={setContentId}
          setContentMode={setContentMode}
          setBundleId={setBundleId}
          setBundleMode={setBundleMode}
          setCatalogId={setCatalogId}
          setCatalogMode={setCatalogMode}
          mode={mode}
          onEdit={onEdit}
          onView={onView}
          onSave={onSave}
          onCancel={onCancel}
          onNext={onNext}
          showColumnPopup={showColumnPopup}
          onCancelTableColumnSelection={props.onCancelTableColumnSelection}
          onSaveTableColumnSelection={props.onSaveTableColumnSelection}
          setSelectionColumns={props.setSelectionColumns}
          signUpApproval={signUpApproval}
          permissions={permissions}
          onViewHandlerList={onViewHandlerList}
          onEditHandlerList={onEditHandlerList}
          routeData={props.routeData}
        />
      )}
    </div>
  );
}

Bundle.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  distributorId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  catalogId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  mode: PropTypes.string.isRequired,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  onEdit: PropTypes.func,
  onNext: PropTypes.func,
  query: PropTypes.object,
  onView: PropTypes.func,
  showColumnPopup: PropTypes.bool,
  onQueryChange: PropTypes.func,
  signUpApproval: PropTypes.shape({
    approvalId: PropTypes.number,
    status: PropTypes.number,
  }),
  permissions: PropTypes.arrayOf(PropTypes.string),
  setContentId: PropTypes.func,
  setContentMode: PropTypes.func,
  setBundleId: PropTypes.func,
  setBundleMode: PropTypes.func,
  setCatalogId: PropTypes.func,
  setCatalogMode: PropTypes.func,
  onViewHandlerList: PropTypes.func,
  onEditHandlerList: PropTypes.func,
  onCancelTableColumnSelection: PropTypes.func,
  setSelectedSubTab: PropTypes.func,
  onSaveTableColumnSelection: PropTypes.func,
  setSelectionColumns: PropTypes.func,
  routeData: PropTypes.object,
};

Bundle.defaultProps = {
  distributorId: "",
  catalogId: "",
  onSave: () => {},
  onCancel: () => {},
  onEdit: () => {},
  onNext: () => {},
  query: {},
  onView: () => {},
  showColumnPopup: false,
  onQueryChange: () => {},
  signUpApproval: { approvalId: 0, status: 0 },
  permissions: [],
  setContentId: () => {},
  setContentMode: () => {},
  setBundleId: () => {},
  setBundleMode: () => {},
  setCatalogId: () => {},
  setCatalogMode: () => {},
  onViewHandlerList: () => {},
  onEditHandlerList: () => {},
  onCancelTableColumnSelection: () => {},
  setSelectedSubTab: () => {},
  onSaveTableColumnSelection: () => {},
  setSelectionColumns: () => {},
  routeData: {},
};

export default Bundle;
